import AutoComplete from "components/atoms/Autocomplete/AutoCompleteApi";
import { useEffect, useState } from "react";
import i18next from "i18next";

export default function AutoCompleteRedux({
  input,
  handleBlur,
  handleFocus,
  meta: { error, touched, invalid, submitFailed },
  InputProps,
  AutocompleteProps,
  mobileTriggerProps,
  ...rest
}: any) {
  const { value, onChange, ...inputRest } = input;

  const [cError, setCError] = useState(i18next.t(`${error}`));
  const [currentLanguage, setCurrlang] = useState(i18next.language);

  if (currentLanguage !== i18next.language) {
    setCurrlang(i18next.language);
  }
  useEffect(() => {
    setCError(i18next.t(`${error}`));
  }, [error, currentLanguage]);

  const shouldShowError = rest.searchForm ? submitFailed && invalid : touched && invalid;

  return (
    <AutoComplete
      {...InputProps}
      {...AutocompleteProps}
      {...rest}
      {...inputRest}
      customLabelStyles={true} // Add this if you want the custom label styles
      focused
      val={value}
      helperText={shouldShowError ? cError : ""}
      error={shouldShowError && !!error}
      handleChange={onChange}
      onSelectionComplete={AutocompleteProps?.onSelectionComplete}
      mobileTriggerProps={mobileTriggerProps}
      onBlur={(e) => {
        handleBlur?.(e);
        e.preventDefault();
      }}
      onFocus={(e) => {
        handleFocus?.(e);
        e.preventDefault();
      }}
    />
  );
}
